import React, { useState } from 'react'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios'
import Payment from './Components/Payment'
import Summary from './Components/Summary'
import YourMobileNumber from './Components/YourMobileNumber'
import YourTelsimSim from './Components/YourTelsim'
import CheckAccount from './Components/CheckAccount'
import Plans from './Components/Plan/Plans'






const SERVER_URL = process.env.REACT_APP_API_URL;
function WmeAddMobilePlan() {

  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activationSubmitData,setActivationSubmitData] = useState([])
  const [activationSuccessMsg, setActivationSuccessMsg] = useState("")
  const [activationSuccessData,setActivationSuccessData] = useState([])
  const [iddCheck,setIddCheck] = useState(false)




  const [commonSession,setCommonSession] = useState(null);
  const getSession = (data) => {
    setCommonSession(data);
  };


  const [userAccountData,setUserAccountData] = useState([]);
  const accountData = (data) => {
    setUserAccountData(data);
  };



  const [planDetails,setplanDetails] = useState([]);
  const planData = (data) => {
    setplanDetails(data);
  };



  const [selectedPlanData,setSelectedPlanData] = useState([]);
  const PlanSelection = (data) => {
    setSelectedPlanData(data);
  };
  
  const updateActivationSubmitData = (data) => {
    setActivationSubmitData(data)
  }

  
  const  getStep=(input)=>{
    setStep(input)
    
  }









  const nextStep = () =>{setStep((prevStep) => prevStep + 1)} 
  const prevStep = () => setStep((prevStep) => prevStep - 1);

  const skipPayment = () =>(setStep(5))






  return (
    <div>
      <div>
        {step === 0 && <CheckAccount nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} handleSession={getSession}  handleAccountCheck={accountData} />}
        {step === 1 && <YourTelsimSim nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} userAccountData={userAccountData} handlePlanDetails={planData}/>}
        {step === 2 && <Plans nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} planDetails={planDetails}  handlePlanSelection={PlanSelection} setIddCheck={setIddCheck}/>}
        {step === 3 && <YourMobileNumber nextStep={nextStep} prevStep={prevStep}  skipPayment={skipPayment} commonSession={commonSession} handleActivaitonSubmitData={updateActivationSubmitData} userAccountData={userAccountData} setActivationSuccessMsg={setActivationSuccessMsg} planDetails={planDetails} selectedPlanData={selectedPlanData} setStep={getStep} iddCheck={iddCheck}/>}
        {step === 4 && <Payment nextStep={nextStep} prevStep={prevStep} userAccountData={userAccountData} selectedPlanData={selectedPlanData} activationSubmitData={activationSubmitData} setActivationSuccessMsg={setActivationSuccessMsg} setActivationSuccessData={setActivationSuccessData} planDetails={planDetails} commonSession={commonSession}   setStep={getStep}/>}
        {step === 5 && <Summary nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} userAccountData={userAccountData} activationSuccessMsg={activationSuccessMsg} selectedPlanData={selectedPlanData} activationSuccessData={activationSuccessData} planDetails={planDetails}  getStep={getStep}  activationSubmitData={activationSubmitData}/>}

        {loading && <p>Loading...</p>}
        {error && <p className="error">{error}</p>}

        
      </div>
    </div>
  );
}

export default WmeAddMobilePlan;
